export const QUEUE_STATUSES = [
    { label: 'NEW', value: 'new' },
	{ label: 'NO_RESPONSE', value: 'no_response' },
	{ label: 'CONFIRMED', value: 'confirmed' },
	{ label: 'TRASH', value: 'trash' },
	{ label: 'SHIFT', value: 'shift' },
	{ label: 'FOREGIN', value: 'foreign' },
	{ label: 'MERGED', value: 'merged' },
	{ label: 'TEMP', value: 'temp' },
	{ label: 'RESIGNED', value: 'resigned' },
	{ label: 'INBOUND', value: 'inbound' },
	{ label: 'RECALL', value: 'recall' },
	{ label: 'TO_CONFIRM', value: 'to_confirm' },
];